const PSEvents = require("../Generic/PSEvents");
const SlotUI = require('SlotUI');

cc.Class({
    extends: cc.Component,

    properties: {
        delayToStart: 1,
        blockLayer: cc.Node,
        nextSceneMethod: {
            type: cc.Component.EventHandler,
            default: null
        },
    },

    onLoad () {
        if (!this.nextSceneMethod) {
            cc.warn('ReplayModeHandler: please set the start game method');
            this.node.removeComponent(this);
            return;
        }

        this.loadEndHandler = () => this.onLoadCompleted();
        PSEvents.getLastOrSubscribe(PSEvents.LOAD_END, this.loadEndHandler);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.LOAD_END, this.loadEndHandler);
    },

    onLoadCompleted() {
        if (SlotUI.isReplayMode()) {
            this._replayModeHandler();
        } else if (SlotUI.isWinRestore()) {
            this._restoreModeHandler();
        } else {
            this.node.removeComponent(this);
        }
    },

    _replayModeHandler () {
        if (this.blockLayer) {
            this.blockLayer.active = true;
        }

        this.scheduleOnce(() => {
            this._callHandler();
        }, this.delayToStart);
    },

    _restoreModeHandler () {
        if (this.blockLayer) {
            this.blockLayer.active = true;
        }

        const winRestoreData = PSEvents.getLast(PSEvents.WIN_RESTORE_RESPONSE);
        const handler = (data) => {
            PSEvents.unsubscribe(PSEvents.WIN_RESTORE_RESPONSE, handler);

            if (data.restoreMode === 'RESTORE') {
                this.scheduleOnce(() => {
                    this._callHandler();
                }, this.delayToStart);
            } else if (this.blockLayer) {
                this.blockLayer.active = false;
            }
        };

        if (winRestoreData) {
            handler(winRestoreData);
        } else {
            this.delayToStart /= 2;
            this.scheduleOnce(() => {
                this.delayToStart = 0;
            }, this.delayToStart);
            PSEvents.subscribe(PSEvents.WIN_RESTORE_RESPONSE, handler);
        }
    },

    _callHandler () {
        // eslint-disable-next-line no-underscore-dangle
        const component = this.nextSceneMethod.target.getComponent(this.nextSceneMethod._componentName);
        const handler = component[this.nextSceneMethod.handler];

        handler.call(component, this.nextSceneMethod.customEventData);
    }

});
